// extracted by mini-css-extract-plugin
module.exports = {"content":"src-components-common-TaxAuthProtocol-protocol-AuthProtocol-SCProtocolContent-__index__content--2B1Zr"};